import axios from 'axios';
import {checkErrors} from './errors';

export const SETCHECKPOINTS = 'checkpoints/SETCHECKPOINTS';
export const LOADCHECKPOINTS_REQUESTED = 'checkpoints/LOADCHECKPOINTS_REQUESTED';
export const LOADCHECKPOINTS_FINISHED = 'checkpoints/LOADCHECKPOINTS_FINISHED';

export const SETCHECKPOINTLINKS = 'checkpoints/SETCHECKPOINTLINKS';
export const LOADCHECKPOINTLINKS_REQUESTED = 'checkpoints/LOADCHECKPOINTLINKS_REQUESTED';
export const LOADCHECKPOINTLINKS_FINISHED = 'checkpoints/LOADCHECKPOINTLINKS_FINISHED';

export const SETCHECKPOINTITEMS = 'checkpoints/SETCHECKPOINTITEMS';
export const LOADCHECKPOINTITEMS_REQUESTED = 'checkpoints/LOADCHECKPOINTITEMS_REQUESTED';
export const LOADCHECKPOINTITEMS_FINISHED = 'checkpoints/LOADCHECKPOINTITEMS_FINISHED';

export const ADDCHECKPOINT_REQUESTED = 'checkpoints/ADDCHECKPOINT_REQUESTED';
export const ADDCHECKPOINT_FINISHED = 'checkpoints/ADDCHECKPOINT_FINISHED';

export const EDITCHECKPOINT_REQUESTED = 'checkpoints/EDITCHECKPOINT_REQUESTED';
export const EDITCHECKPOINT_FINISHED = 'checkpoints/EDITCHECKPOINT_FINISHED';

export const REMOVECHECKPOINT_REQUESTED = 'checkpoints/REMOVECHECKPOINT_REQUESTED';
export const REMOVECHECKPOINT_FINISHED = 'checkpoints/REMOVECHECKPOINT_FINISHED';

export const ADDCHECKPOINTLINK_REQUESTED = 'checkpoints/ADDCHECKPOINTLINK_REQUESTED';
export const ADDCHECKPOINTLINK_FINISHED = 'checkpoints/ADDCHECKPOINTLINK_FINISHED';

export const EDITCHECKPOINTLINK_REQUESTED = 'checkpoints/EDITCHECKPOINTLINK_REQUESTED';
export const EDITCHECKPOINTLINK_FINISHED = 'checkpoints/EDITCHECKPOINTLINK_FINISHED';

export const REMOVECHECKPOINTLINK_REQUESTED = 'checkpoints/REMOVECHECKPOINTLINK_REQUESTED';
export const REMOVECHECKPOINTLINK_FINISHED = 'checkpoints/REMOVECHECKPOINTLINK_FINISHED';

export const ADDCHECKPOINTAMENITY_REQUESTED = 'checkpoints/ADDCHECKPOINTAMENITY_REQUESTED';
export const ADDCHECKPOINTAMENITY_FINISHED = 'checkpoints/ADDCHECKPOINTAMENITY_FINISHED';

export const REMOVECHECKPOINTAMENITY_REQUESTED = 'checkpoints/REMOVECHECKPOINTAMENITY_REQUESTED';
export const REMOVECHECKPOINTAMENITY_FINISHED = 'checkpoints/REMOVECHECKPOINTAMENITY_FINISHED';

export const ADDCHECKPOINTKIOSK_REQUESTED = 'checkpoints/ADDCHECKPOINTKIOSK_REQUESTED';
export const ADDCHECKPOINTKIOSK_FINISHED = 'checkpoints/ADDCHECKPOINTKIOSK_FINISHED';

export const REMOVECHECKPOINTKIOSK_REQUESTED = 'checkpoints/REMOVECHECKPOINTKIOSK_REQUESTED';
export const REMOVECHECKPOINTKIOSK_FINISHED = 'checkpoints/REMOVECHECKPOINTKIOSK_FINISHED';

export const ADDCHECKPOINTSTOREASSIGNMENT_REQUESTED = 'checkpoints/ADDCHECKPOINTSTOREASSIGNMENT_REQUESTED';
export const ADDCHECKPOINTSTOREASSIGNMENT_FINISHED = 'checkpoints/ADDCHECKPOINTSTOREASSIGNMENT_FINISHED';

export const REMOVECHECKPOINTSTOREASSIGNMENT_REQUESTED = 'checkpoints/REMOVECHECKPOINTSTOREASSIGNMENT_REQUESTED';
export const REMOVECHECKPOINTSTOREASSIGNMENT_FINISHED = 'checkpoints/REMOVECHECKPOINTSTOREASSIGNMENT_FINISHED';

const initialState = {
  checkpoints: [],
  checkpointLinks: [],
  checkpointlinkslimit: 10000,
  checkpointlinksskip: 0,
  checkpointItems: [],
  isLoadingCheckpoints: false,
  isLoadingCheckpointLinks: false,
  isLoadingCheckpointItems: false,
  isAddingCheckpoint: false,
  isEditingCheckpoint: false,
  isRemovingCheckpoint: false,
  isAddingCheckpointLink: false,
  isEditingCheckpointLink: false,
  isAddingCheckpointLinkFrom: null,
  isAddingCheckpointLinkTo: null,
  isRemovingCheckpointLink: false,
  isRemovingCheckpointLinkID: null,
  isAddingCheckpointAmenity: false,
  isRemovingCheckpointAmenity: false,
  isAddingCheckpointKiosk: false,
  isRemovingCheckpointKiosk: false,
  isAddingCheckpointStoreAssignment: false,
  isRemovingCheckpointStoreAssignment: false,
};

export default (state = initialState, action) => {
  switch (action.type) {
  case SETCHECKPOINTS:
    return {
      ...state,
      checkpoints: action.checkpoints
    };

  case LOADCHECKPOINTS_REQUESTED:
    return {
      ...state,
      isLoadingCheckpoints: true
    };

  case LOADCHECKPOINTS_FINISHED:
    return {
      ...state,
      isLoadingCheckpoints: false
    };

  case SETCHECKPOINTLINKS:
    return {
      ...state,
      checkpointLinks: action.checkpointLinks
    };

  case LOADCHECKPOINTLINKS_REQUESTED:
    return {
      ...state,
      isLoadingCheckpointLinks: true
    };

  case LOADCHECKPOINTLINKS_FINISHED:
    return {
      ...state,
      isLoadingCheckpointLinks: false
    };

  case SETCHECKPOINTITEMS:
    return {
      ...state,
      checkpointItems: action.checkpointItems
    };

  case LOADCHECKPOINTITEMS_REQUESTED:
    return {
      ...state,
      isLoadingCheckpointItems: true
    };

  case LOADCHECKPOINTITEMS_FINISHED:
    return {
      ...state,
      isLoadingCheckpointItems: false
    };

  case ADDCHECKPOINT_REQUESTED:
    return {
      ...state,
      isAddingCheckpoint: true
    };

  case ADDCHECKPOINT_FINISHED:
    return {
      ...state,
      isAddingCheckpoint: false
    };

  case EDITCHECKPOINT_REQUESTED:
    return {
      ...state,
      isEditingCheckpoint: true
    };

  case EDITCHECKPOINT_FINISHED:
    return {
      ...state,
      isEditingCheckpoint: false
    };

  case REMOVECHECKPOINT_REQUESTED:
    return {
      ...state,
      isRemovingCheckpoint: true
    };

  case REMOVECHECKPOINT_FINISHED:
    return {
      ...state,
      isRemovingCheckpoint: false
    };

  case ADDCHECKPOINTLINK_REQUESTED:
    return {
      ...state,
      isAddingCheckpointLink: true,
      isAddingCheckpointLinkFrom: action.isAddingCheckpointLinkFrom,
      isAddingCheckpointLinkTo: action.isAddingCheckpointLinkTo
    };

  case ADDCHECKPOINTLINK_FINISHED:
    return {
      ...state,
      isAddingCheckpointLink: false,
      isAddingCheckpointLinkFrom: null,
      isAddingCheckpointLinkTo: null,
    };

  case EDITCHECKPOINTLINK_REQUESTED:
    return {
      ...state,
      isEditingCheckpointLink: true,
    };

  case EDITCHECKPOINTLINK_FINISHED:
    return {
      ...state,
      isEditingCheckpointLink: false,
    };

  case REMOVECHECKPOINTLINK_REQUESTED:
    return {
      ...state,
      isRemovingCheckpointLink: true,
      isRemovingCheckpointLinkID: action.isRemovingCheckpointLinkID
    };

  case REMOVECHECKPOINTLINK_FINISHED:
    return {
      ...state,
      isRemovingCheckpointLink: false,
      isRemovingCheckpointLinkID: null,
    };

  case ADDCHECKPOINTAMENITY_REQUESTED:
    return {
      ...state,
      isAddingCheckpointAmenity: true
    };

  case ADDCHECKPOINTAMENITY_FINISHED:
    return {
      ...state,
      isAddingCheckpointAmenity: false
    };

  case REMOVECHECKPOINTAMENITY_REQUESTED:
    return {
      ...state,
      isRemovingCheckpointAmenity: true
    };

  case REMOVECHECKPOINTAMENITY_FINISHED:
    return {
      ...state,
      isRemovingCheckpointAmenity: false
    };

  case ADDCHECKPOINTKIOSK_REQUESTED:
    return {
      ...state,
      isAddingCheckpointKiosk: true
    };

  case ADDCHECKPOINTKIOSK_FINISHED:
    return {
      ...state,
      isAddingCheckpointKiosk: false
    };

  case REMOVECHECKPOINTKIOSK_REQUESTED:
    return {
      ...state,
      isRemovingCheckpointKiosk: true
    };

  case REMOVECHECKPOINTKIOSK_FINISHED:
    return {
      ...state,
      isRemovingCheckpointKiosk: false
    };

  case ADDCHECKPOINTSTOREASSIGNMENT_REQUESTED:
    return {
      ...state,
      isAddingCheckpointStoreAssignment: true
    };

  case ADDCHECKPOINTSTOREASSIGNMENT_FINISHED:
    return {
      ...state,
      isAddingCheckpointStoreAssignment: false
    };

  case REMOVECHECKPOINTSTOREASSIGNMENT_REQUESTED:
    return {
      ...state,
      isRemovingCheckpointStoreAssignment: true
    };

  case REMOVECHECKPOINTSTOREASSIGNMENT_FINISHED:
    return {
      ...state,
      isRemovingCheckpointStoreAssignment: false
    };
  
  default:
    return state;
  }
};

export const loadCheckpoints = (cb) => {
  return dispatch => {
    dispatch({
      type: LOADCHECKPOINTS_REQUESTED
    });

    axios.get(`${window.endpoint}/checkpoints`, { headers: { Authorization: localStorage.getItem(window.token) } }).then(response => {

      dispatch({
        type: SETCHECKPOINTS,
        checkpoints: response.data.checkpoints
      });

      dispatch({
        type: LOADCHECKPOINTS_FINISHED
      });

      if (cb instanceof Function) { cb(); }
      
    }).catch((error) => {
      checkErrors(error);
    });
    
    
  };
};

export const loadCheckpointLinks = (cb) => {
  return (dispatch, getState) => {

    const checkpointsState = getState().checkpoints;

    dispatch({
      type: LOADCHECKPOINTLINKS_REQUESTED
    });

    axios.get(`${window.endpoint}/v2/checkpointlinks?limit=${checkpointsState.checkpointlinkslimit}&skip=${checkpointsState.checkpointlinksskip}`, { headers: { Authorization: localStorage.getItem(window.token) } }).then(response => {

      dispatch({
        type: SETCHECKPOINTLINKS,
        checkpointLinks: response.data.checkpointlinks
      });

      dispatch({
        type: LOADCHECKPOINTLINKS_FINISHED
      });
      
      if (cb instanceof Function) { cb(); }

    }).catch((error) => {
      checkErrors(error);
    });
    
  };
};

export const loadCheckpointItems = (cb) => {
  return dispatch => {
    dispatch({
      type: LOADCHECKPOINTITEMS_REQUESTED
    });

    axios.get(`${window.endpoint}/checkpointitems`, { headers: { Authorization: localStorage.getItem(window.token) } }).then(response => {
      dispatch({
        type: SETCHECKPOINTITEMS,
        checkpointItems: response.data.checkpointItems
      });

      dispatch({
        type: LOADCHECKPOINTITEMS_FINISHED
      });

      if (cb instanceof Function) { cb(); }
      
    }).catch((error) => {
      checkErrors(error);
    });
    
  };
};


export const addCheckpoint = ({checkpoint_name, x, y, floor_plan_id}, cb) => {
  return dispatch => {
    dispatch({
      type: ADDCHECKPOINT_REQUESTED
    });

    const formData = new FormData();
    formData.append('data', JSON.stringify({ checkpoint_name, x, y, floor_plan_id }));

    axios.post(`${window.endpoint}/checkpoints`, formData, { headers: { Authorization: localStorage.getItem(window.token) } }).then(response => {

      if (cb instanceof Function) { cb(response.data.data.checkpoint_id); }

      dispatch({
        type: ADDCHECKPOINT_FINISHED
      });
      
    }).catch((error) => {
      checkErrors(error);
    });
    
  };
};

export const editCheckpoint = ({id, checkpoint_name, x, y, floor_plan_id}, cb) => {
  return dispatch => {
    dispatch({
      type: EDITCHECKPOINT_REQUESTED
    });

    const formData = new FormData();
    formData.append('data', JSON.stringify({ checkpoint_name, x, y, floor_plan_id }));

    axios.post(`${window.endpoint}/checkpoints/${id}`, formData, { headers: { Authorization: localStorage.getItem(window.token) } }).then(response => {

      if (cb instanceof Function) { cb(); }

      dispatch({
        type: EDITCHECKPOINT_FINISHED
      });
      
    }).catch((error) => {
      checkErrors(error);
    });
    
  };
};

export const removeCheckpoint = (checkpoint_id, cb) => {
  return dispatch => {
    dispatch({
      type: REMOVECHECKPOINT_REQUESTED
    });

    axios.delete(`${window.endpoint}/checkpoints/${checkpoint_id}`, { headers: { Authorization: localStorage.getItem(window.token) } }).then(response => {

      if (cb instanceof Function) { cb(); }

      dispatch({
        type: REMOVECHECKPOINT_FINISHED
      });
      
    }).catch((error) => {
      checkErrors(error);
    });
    
  };
};

export const addCheckpointLink = ({from, to, weight, checkpointlink_categories, description }, cb) => {
  return (dispatch, getState) => {
    
    dispatch({
      type: ADDCHECKPOINTLINK_REQUESTED,
      isAddingCheckpointLinkFrom: from,
      isAddingCheckpointLinkTo: to,
    });

    const formData = new FormData();
    formData.append('data', JSON.stringify({ from, to, weight, checkpointlink_categories, description }));

    axios.post(`${window.endpoint}/checkpointlinks`, formData, { headers: { Authorization: localStorage.getItem(window.token) } }).then(response => {

      dispatch({
        type: ADDCHECKPOINTLINK_FINISHED
      });

      if (cb instanceof Function) { cb(response.data); }
      
    }).catch((error) => {
      checkErrors(error);
    });
    
  };
};

export const editCheckpointLink = (id, {from, to, weight, checkpointlink_categories, description}, cb) => {
  return (dispatch, getState) => {
    
    dispatch({
      type: EDITCHECKPOINTLINK_REQUESTED
    });

    const formData = new FormData();
    formData.append('data', JSON.stringify({ from, to, weight, checkpointlink_categories, description }));

    axios.post(`${window.endpoint}/v2/checkpointlinks/${id}`, formData, { headers: { Authorization: localStorage.getItem(window.token) } }).then(response => {

      dispatch({
        type: EDITCHECKPOINTLINK_FINISHED
      });

      if (cb instanceof Function) { cb(response.data); }
      
    }).catch((error) => {
      checkErrors(error);
    });
    
  };
};

export const removeCheckpointLink = (checkpointlink_id, cb) => {
  return dispatch => {
    dispatch({
      type: REMOVECHECKPOINTLINK_REQUESTED,
      isRemovingCheckpointLinkID: checkpointlink_id
    });

    axios.delete(`${window.endpoint}/checkpointlinks/${checkpointlink_id}`, { headers: { Authorization: localStorage.getItem(window.token) } }).then(response => {

      dispatch({
        type: REMOVECHECKPOINTLINK_FINISHED
      });

      if (cb instanceof Function) { cb(); }
      
    }).catch((error) => {
      checkErrors(error);
    });
    
  };
};

export const addCheckpointAmenity = ({checkpoint_id, mil_id}, cb) => {
  return dispatch => {
    dispatch({
      type: ADDCHECKPOINTAMENITY_REQUESTED
    });

    const formData = new FormData();
    formData.append('data', JSON.stringify({ checkpoint_id, mil_id }));

    axios.post(`${window.endpoint}/checkpointitems`, formData, { headers: { Authorization: localStorage.getItem(window.token) } }).then(response => {

      dispatch({
        type: ADDCHECKPOINTAMENITY_FINISHED
      });

      if (cb instanceof Function) { cb(response); }
      
    }).catch((error) => {
      checkErrors(error);
    });
    
  };
};

export const removeCheckpointAmenity = (checkpointitem_id, cb) => {
  return dispatch => {
    dispatch({
      type: REMOVECHECKPOINTAMENITY_REQUESTED
    });

    axios.delete(`${window.endpoint}/checkpointitems/${checkpointitem_id}`, { headers: { Authorization: localStorage.getItem(window.token) } }).then(response => {

      dispatch({
        type: REMOVECHECKPOINTAMENITY_FINISHED
      });

      if (cb instanceof Function) { cb(); }
      
    }).catch((error) => {
      checkErrors(error);
    });
    
  };
};

export const addCheckpointKiosk = ({checkpoint_id, mil_id}, cb) => {
  return dispatch => {
    dispatch({
      type: ADDCHECKPOINTKIOSK_REQUESTED
    });

    const formData = new FormData();
    formData.append('data', JSON.stringify({ checkpoint_id, mil_id }));

    axios.post(`${window.endpoint}/checkpointitems`, formData, { headers: { Authorization: localStorage.getItem(window.token) } }).then(response => {

      dispatch({
        type: ADDCHECKPOINTKIOSK_FINISHED
      });

      if (cb instanceof Function) { cb(response); }
      
    }).catch((error) => {
      checkErrors(error);
    });
    
  };
};

export const removeCheckpointKiosk = (checkpointitem_id, cb) => {
  return dispatch => {
    dispatch({
      type: REMOVECHECKPOINTKIOSK_REQUESTED
    });

    axios.delete(`${window.endpoint}/checkpointitems/${checkpointitem_id}`, { headers: { Authorization: localStorage.getItem(window.token) } }).then(response => {

      dispatch({
        type: REMOVECHECKPOINTKIOSK_FINISHED
      });

      if (cb instanceof Function) { cb(); }
      
    }).catch((error) => {
      checkErrors(error);
    });
    
  };
};

export const addCheckpointStoreAssignment = ({checkpoint_id, mil_id}, cb) => {
  return dispatch => {
    dispatch({
      type: ADDCHECKPOINTSTOREASSIGNMENT_REQUESTED
    });

    const formData = new FormData();
    formData.append('data', JSON.stringify({ checkpoint_id, mil_id }));

    axios.post(`${window.endpoint}/checkpointitems`, formData, { headers: { Authorization: localStorage.getItem(window.token) } }).then(response => {

      dispatch({
        type: ADDCHECKPOINTSTOREASSIGNMENT_FINISHED
      });

      if (cb instanceof Function) { cb(response); }
      
    }).catch((error) => {
      checkErrors(error);
    });
    
  };
};

export const removeCheckpointStoreAssignment = (checkpointitem_id, cb) => {
  return dispatch => {
    dispatch({
      type: REMOVECHECKPOINTSTOREASSIGNMENT_REQUESTED
    });

    axios.delete(`${window.endpoint}/checkpointitems/${checkpointitem_id}`, { headers: { Authorization: localStorage.getItem(window.token) } }).then(response => {

      dispatch({
        type: REMOVECHECKPOINTSTOREASSIGNMENT_FINISHED
      });

      if (cb instanceof Function) { cb(); }
      
    }).catch((error) => {
      checkErrors(error);
    });
    
  };
};




// WEBPACK FOOTER //
// ./src/reducers/checkpoints.js